import { createCachedSelector } from "re-reselect";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import { TripDetailsFetchStatusKey } from "../../state/trip-details-fetch-status";
import {
  getInventoryReady,
  getTripDetailsFetchStatus
} from "../state-accessors";

export const isTripVehicleLoading = createCachedSelector(
  [
    getTripDetailsFetchStatus,
    getInventoryReady,
    (_state: ResultsReduxState, trip_id: string) => trip_id
  ],
  (fetch_status, inventory_ready, trip_id) => {
    return (
      TripDetailsFetchStatusKey.Loading === fetch_status[trip_id] ||
      !inventory_ready
    );
  }
)((_state, trip_id) => trip_id);
